// extracted by mini-css-extract-plugin
export default {"settingsPage":"SettingsPage_settingsPage__fi7Z0"};